import { useAlert } from '../../../../../context/AlertContext'
import { Autocomplete, Dialog, DialogActions, DialogContent, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useAppData } from '../../../../../context/AppDataContext'
import { Add, DoubleArrow } from '@mui/icons-material';
import SelectCustomer from '../../customer/components/SelectCustomer';
import invoiceServices from '../invoiceServices';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

function GenerateInvoice({callBack}) {
    const {AppAlert} = useAlert();
    const {companyDD} = useAppData();
    const [selectedCompany,setSelectedCompany] = useState(null);
    const [selectedCustomer,setSelectedCustomer] = useState(null);
    const [invoiceNumber,setInvoiceNumber] = useState("");

    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const navigate = useNavigate();
    

    const onSubmit = () => {
        let payload = { 
            companyId:selectedCompany.value,
            customerId:selectedCustomer.value,
            invoiceNumber:invoiceNumber,
            invoiceDate:moment().format(moment.HTML5_FMT.DATE),
            paymentDueDate:moment().format(moment.HTML5_FMT.DATE),
        }
        invoiceServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            if(callBack){
                callBack();
            }
            navigate("/invoice/details/"+res.id)
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }
    
    
    return (
        <>
            <button type="button" className="btn btn-primary" onClick={()=>setDialogStatus(true)} ><Add /> Generate New Invoice</button>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <Autocomplete
                                options={companyDD}
                                onChange={(event, newValue) => {
                                    setSelectedCompany(newValue);
                                }}
                                className='bg-white'
                                value={selectedCompany}
                                renderInput={(params) => <TextField {...params} size="small" label='Select Company / Firm' /> } 
                            />
                        </div>
                    </div>

                    {selectedCompany !== null &&
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <SelectCustomer  selectedCustomer={selectedCustomer} setSelectedCustomer={setSelectedCustomer} />
                        </div>
                    </div>
                    }


                    {selectedCompany !== null && selectedCustomer !== null &&
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <div class="form-floating">
                                <input type='text' className='form-control' value={invoiceNumber} onChange={(e)=>setInvoiceNumber(e.target.value)} />
                                <label>Invoice Number</label>
                            </div>
                        </div>
                    </div>
                    }
                </DialogContent>
                <DialogActions>
                    <button disabled={selectedCustomer === null || selectedCompany === null || invoiceNumber === ""} className='btn btn-outline-primary' onClick={onSubmit}>Continue <DoubleArrow/> </button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default GenerateInvoice